import clsx from "clsx";
import type React from "react";
import { useState } from "react";
import Button from "@/components/Button";
import DeskIllustration from "@/images/Desk_Illustration.svg?react";
import styles from "./EmptyList.module.scss";

interface Props {
  chooseFile: (e: React.MouseEvent) => void;
  supportsFrogs: boolean;
}
export default function EmptyList({ chooseFile, supportsFrogs }: Props) {
  const [isOver, setIsOver] = useState(false);

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    setIsOver(true);
    e.preventDefault();
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    setIsOver(false);
    e.preventDefault();
  };

  return (
    <div
      id="empty-document-list"
      className={clsx(styles.emptyDocumentList, {
        [styles.dropping]: isOver,
      })}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDragLeave}
      style={{ pointerEvents: "none" }}
    >
      <DeskIllustration />
      <p className="lead">Lighten your workload and reclaim your time!</p>
      <p className={styles.smaller}>
        Briefpoint currently accepts the following state court documents:
      </p>
      <ul>
        <li>Requests for Admission</li>
        <li>Requests for Production</li>
        <li>{supportsFrogs && "Special "}Interrogatories</li>
        {supportsFrogs && <li>Form Interrogatories</li>}
      </ul>
      <p>
        Drag PDF files here to upload, or{" "}
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: replace with button */}
        <span
          className="btn-link cursor-pointer p-0"
          style={{ pointerEvents: "initial" }}
          onClick={(e) => chooseFile(e)}
        >
          browse files
        </span>{" "}
        from your computer.
      </p>
      <Button
        className="mt-2"
        onClick={chooseFile}
        style={{ pointerEvents: "initial" }}
      >
        Upload Document
      </Button>
    </div>
  );
}
